import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import axios from './../../../constants/axios';
import moment from 'moment';
import classname from 'classnames';
import DatePicker from 'react-datepicker';

class PurchaseHome extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         purchases: [],
         startDate: null,
         endDate: null,
      };
   }


   componentDidMount() {
      axios.get('inventoryPurchases')
         .then((res) => {
            this.setState({
               purchases: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }


   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate) {
         axios.get(`inventoryPurchases?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  purchases: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   render() {
      const { purchases } = this.state;
      return (
         <div className="PurchaseHome" >
            <h1 >Purchase Home</h1 >
            <div >
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange} />
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange} />
               <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
            </div >
            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Contact Name</th >
                  <th >Billed</th >
                  <th >Paid Amount</th >
                  <th >Due</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {purchases.map((purchase) => (
                  <tr key={purchase.id} className={classname({ 'due_invoice': purchase.due !== 0 })} >
                     <td >{purchase.id}</td >
                     <td >{purchase.contact_name}</td >
                     <td >{purchase.total_amount}</td >
                     <td >{purchase.paid_amount}</td >
                     <td >{purchase.due}</td >
                     <td >{purchase.created_at}</td >
                     <td >
                        <Link to={`/purchase/purchaseInvoiceDetail/${purchase.id}`} >Details</Link >
                     </td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}

PurchaseHome.propTypes = {};


export default PurchaseHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchaseHome.js
 **/